<template>
    <v-card>
        <v-card-title class="justify-center">
            <h2>Conveniados</h2>
        </v-card-title>
        <v-alert type="error" outline :value="true" v-if="cpfs_nao_usados.length > 0 && permissaoExcluir">
          <v-layout class="pa-0 ma-0">
            <h4>
              {{ cpfs_nao_usados.length === 1 ? `${cpfs_nao_usados.length} CPF` : `${cpfs_nao_usados.length} CPFs` }}
              da lista não {{ cpfs_nao_usados.length === 1 ? 'está sendo usado' : 'estão sendo usados' }}
            </h4>
            <v-spacer></v-spacer>
            <v-btn small round flat color="error" @click="removerConveniado(undefined)">
              Remover da lista
            </v-btn>
          </v-layout>
        </v-alert>
        <v-toolbar>
            <v-layout class="mt-2">
                <v-text-field
                label="Quantidade de uso menor que"
                v-model="qtd_uso"
                type="number"
                ></v-text-field>
              <v-menu
                ref="menu1"
                v-model="menu1"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
              >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="computedDateFormatted"
                  label="Mês"
                  persistent-hint
                  prepend-icon="mdi-calendar"
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date"
                no-title
                @input="menu1 = false"
                type="month"
                locale="pt-br"
                color="info"
              ></v-date-picker>
              </v-menu>
              </v-layout>
              <v-btn icon>
                  <v-icon color="info" @click="pegarConveniados">search</v-icon>
              </v-btn>
        </v-toolbar>
        <v-card-text>
            <v-list>
                <v-list-tile v-for="(conveniado, index) in conveniados" :key="index">
                    <v-list-tile-avatar>
                        <v-img
                            v-if="conveniado.pessoa.url_imagem_perfil" :src="conveniado.pessoa.url_imagem_perfil"
                            style="border-radius: 2em;"
                        />
                        <v-icon v-else>face</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                        <v-list-tile-title>
                            Nome: <b>{{conveniado.pessoa.nome_completo}}</b>
                        </v-list-tile-title>
                        <v-list-tile-sub-title>
                            Quantidade de uso: <b>{{conveniado.numero_compras || 0}}</b>
                        </v-list-tile-sub-title>
                    </v-list-tile-content>
                    <v-list-tile-action v-if="permissaoExcluir">
                        <v-btn icon color="error" small @click="removerConveniado(conveniado.pessoa.cpf)">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-list-tile-action>
                </v-list-tile>
            </v-list>
        </v-card-text>
        <v-card-actions>
            <v-btn block @click="$emit('fechar')">Fechar</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
  props: ['convenio_posto'],
  data: () => ({
    conveniados: [],
    date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString(),
    qtd_uso: undefined,
    mes: undefined,
    menu1: false,
    convenio_posto_data: {
      convenio: {
        cpfs_permitidos: []
      }
    }
  }),
  computed: {
    posto () {
      return this.$store.getters.posto
    },
    computedDateFormatted () {
      return this.formatDate(this.date)
    },
    permissaoExcluir () {
      if (!this.posto || !this.convenio_posto) return false
      if (this.convenio_posto.convenio.representante) return false
      return true
    },
    cpfs_nao_usados () {
      const list = []
      if (this.convenio_posto_data && this.conveniados) {
        const lista = this.convenio_posto_data.convenio.cpfs_permitidos
        for (var i in lista) {
          const found = this.conveniados.find(conveniado => conveniado.pessoa.cpf === lista[i])
          if (!found) list.push(lista[i])
        }
        return list
      }
      return list
    }
  },
  beforeMount () {
    if (this.convenio_posto) {
      this.pegarConvenio()
      this.pegarConveniados()
    }
  },
  methods: {
    async pegarConveniados () {
      const [month, year] = this.computedDateFormatted.split('/')
      await this.$store.dispatch('pegarConveniados', {
        id_convenio: this.convenio_posto.id,
        cnpj: this.posto.cnpj,
        mes: month,
        ano: year
      }).then(json => {
        this.conveniados = json
      })
      if (this.qtd_uso && this.conveniados.length > 0) {
        this.conveniados = this.conveniados.filter((c) => {
          return c.numero_compras < this.qtd_uso
        })
      }
    },
    pegarConvenio () {
      this.$store.dispatch('detalharConvenio', {
        id: this.convenio_posto.id
      }).then(json => {
        this.convenio_posto_data = json
      })
    },
    removerConveniado (cpf) {
      let cpfs = []
      if (cpf) {
        cpfs = this.convenio_posto_data.convenio.cpfs_permitidos
        cpfs = cpfs.filter((item) => item !== cpf)
      } else {
        cpfs = this.conveniados.map((c) => c.pessoa.cpf)
      }
      this.$store.dispatch('atualizarConvenio', {
        id: this.convenio_posto_data.id,
        data: { ...this.convenio_posto_data, cpfs_permitidos: cpfs }
      }).then(() => {
        this.$emit('carregar')
        this.pegarConvenio()
        this.pegarConveniados()
      })
    },
    formatDate (date) {
      if (!date) return null

      const [year, month] = date.split('-')
      return `${month}/${year}`
    }
  }
}
</script>
